import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconCustomNeat = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Neat'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 0 124 60' ref={ref} title={title} size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path
        d='m13.468332 15.5818948c8.4324939 0 13.4671248 5.1380475 13.4671248 13.7453491v10.5454695c0 2.6267037-1.7502313
        4.3794501-4.3761818 4.3794501l.0006035-14.9249196c0-6.1225329-3.3139725-9.6346695-9.0915465-9.6346695-5.77757407
        0-9.09094306 3.5121366-9.09094306 9.6346695l-.00120705 10.5454695c0 2.6267037-1.75083488 4.3794501-4.37618189
        4.3794501v-4.3794501l.00181058-10.5454695c0-8.6073016 5.03402746-13.7453491 13.46652142-13.7453491zm32.5262389-.0000604c8.4240445
        0 14.5383872 6.0283122 14.5383872 14.3348324v1.5721568h-24.657742c.645775 5.1948214 4.6616506 8.651996 10.1193548
        8.651996 3.3833782 0 6.1324485-1.1614512 7.9001821-3.3049719 1.7188479-2.0994302 4.0309639-2.1392928
        5.6490226-1.3209016l-.1665738.398022c-2.1455422 5.1440873-7.27372 8.339135-13.3826309 8.339135-8.4868114
        0-14.6464187-6.0295201-14.6464187-14.3354363 0-8.3065202 6.1596073-14.3348324 14.6464187-14.3348324zm32.4664896-.0004832c8.5912218
        0 14.5921012 5.9612706 14.5921012 14.4966987l-.001207 14.174174c-2.4636015 0-4.1058014-1.6446342-4.1058014-4.1100756v-1.8083124c-2.153388
        3.7368167-6.1553825 5.918388-11.0210257 5.918388-8.1759945 0-14.1098822-5.9612705-14.1098822-14.174174 0-8.5354281 6.0220028-14.4966987
        14.6458151-14.4966987zm23.3492935-6.3627956v8.283569h10.212298c0 2.6285156-1.750232 4.3794501-4.375579 4.3794501h-5.836719v11.6912172c0
        4.3456274 2.277111 6.7385913 6.412485 6.7385913 1.639786 0 2.987464-.3762788 4.016479-1.1016573.589647 5.4195016-5.700322 5.1446912-6.71787
        4.9725573-5.114901-.9639501-8.0866726-4.7774722-8.0866726-10.6094913v-22.6026978zm17.085637 26.1678034c1.839554 0 3.3357
        1.4972634 3.3357 3.3369828 0 1.8409273-1.496146 3.3387947-3.3357 3.3387947-1.83895 0-3.335096-1.4978674-3.335096-3.3387947
        0-1.8397194 1.496146-3.3369828 3.335096-3.3369828zm-40.4349305-15.6931202c-6.015364 0-10.2171263 4.2030883-10.2171263 10.2235488
        0 6.0198565 4.2017623 10.2241528 10.2171263 10.2241528 6.0153641 0 10.2165229-4.2042963 10.2165229-10.2241528
        0-6.0204605-4.2011588-10.2235488-10.2165229-10.2235488zm-32.4664896-.0001208c-5.175253 0-9.0444714 3.0428451-9.9811469
        7.7931382h19.9061657c-.9608167-4.7508971-4.808308-7.7931382-9.9250188-7.7931382z'
      />
    </Icon>
  )
}

IconCustomNeat.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconCustomNeat
